import { render, staticRenderFns } from "./ProfileTalentPackagesListItemSingleOption.vue?vue&type=template&id=149b61e3"
import script from "./ProfileTalentPackagesListItemSingleOption.vue?vue&type=script&lang=js"
export * from "./ProfileTalentPackagesListItemSingleOption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports